import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Bus, School, CarTaxiFront, Car, UserCheck, Crown } from "lucide-react";

const services = [
  {
    title: "Personel Taşımacılığı",
    description: "İşinizin gerektirdiği tüm personeli güvenle taşıyoruz.",
    icon: <Bus size={40} />, 
  },
  {
    title: "Öğrenci Taşımacılığı",
    description: "Öğrencilerin güvenli taşımacılığı bizim için önemli.",
    icon: <School size={40} />, 
  },
  {
    title: "Transfer Hizmetleri",
    description: "Transfer hizmetlerimiz ile artık yanınızda.",
    icon: <CarTaxiFront size={40} />, 
  },
  {
    title: "Araç Kiralama Hizmetleri",
    description: "Yeni ve son model araçlardan oluşan filomuz.",
    icon: <Car size={40} />, 
  },
  {
    title: "Şoförlü Araç Kiralama",
    description: "Trafik derdine son! Şoförlü araç kiralama hizmeti.",
    icon: <UserCheck size={40} />, 
  },
  {
    title: "VIP Transfer Hizmetleri",
    description: "VIP araçlar ile transfer hizmetlerimiz var!",
    icon: <Crown size={40} />, 
  },
];

const ServicesSection: React.FC = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="py-12 bg-white">
      <motion.div 
        initial={{ opacity: 0, y: -50 }} 
        animate={isInView ? { opacity: 1, y: 0 } : {}} 
        transition={{ duration: 0.8 }}
        className="max-w-6xl mx-auto text-center"
      >
        <h2 className="text-[#092049] font-semibold uppercase text-sm">
          Sunduğumuz Hizmetler
        </h2>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
          Öğrenci ve Personel Taşımacılığı Hizmetlerimiz
        </h1>
      </motion.div>
      
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="relative group bg-white rounded-xl shadow-lg p-6 overflow-hidden border-b-4 border-[#092049] transition-all duration-300"
            whileHover={{ y: -5 }}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            {/* Arka plan hover efekti */}
            <motion.div 
              className="absolute inset-0 bg-[#092049] scale-y-0 group-hover:scale-y-100 transition-transform duration-500 origin-bottom" 
            />

            {/* İçerik */}
            <div className="relative z-10 flex flex-col items-center text-center">
              <span className="text-4xl text-[#092049] group-hover:text-white transition-colors">{service.icon}</span>
              <motion.h3 
                className="mt-4 text-lg font-semibold text-[#092049] group-hover:text-white transition-colors"
                whileHover={{ scale: 1.1 }}
              >
                {service.title}
              </motion.h3>
              <p className="text-gray-600 group-hover:text-white transition-colors text-sm mt-2">
                {service.description}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
